import { useState } from "react";

export const useControls = () => {
  const [panDiagonalX, setPanDiagonalX] = useState(0);
  const [panDiagonalY, setPanDiagonalY] = useState(0);
  const [zoom, setZoom] = useState(1);
  const [rotation, setRotation] = useState(0);
  const [flip, setFlip] = useState(false);

  const resetAll = () => {
    setPanDiagonalX(0);
    setPanDiagonalY(0);
    setZoom(1);
    setRotation(0);
    setFlip(false);
  };

  const zoomIn = (): void => setZoom(zoom + 0.2);

  const zoomOut = () => {
    if (zoom >= 1) setZoom(zoom - 0.2);
  };

  const rotateLeft = () => {
    if (rotation === -3) setRotation(0);
    else setRotation(rotation - 1);
  };

  const flipImage = () => setFlip(!flip);

  const onPan = (diagonalX: number, diagonalY: number) => {
    setPanDiagonalX(diagonalX);
    setPanDiagonalY(diagonalY);
  };

  const onWheel = (e: React.WheelEvent<EventTarget>) =>
    Math.sign(e.deltaY) < 0 ? setZoom((zoom || 0) + 0.1) : (zoom || 0) > 1 && setZoom((zoom || 0) - 0.1);

  return {
    zoomIn,
    zoomOut,
    rotateLeft,
    flipImage,
    resetAll,
    zoom,
    panDiagonalX,
    panDiagonalY,
    onPan,
    setZoom,
    rotation,
    flip,
    onWheel,
  };
};
